module.exports = __webpack_public_path__ + "img/galerie-19.7ec8bf86.jpg";